export default __webpack_public_path__ + "static/media/roadmap-2.b732bc27.png";